import React from "react";

import {
  Box,
  type BoxProps,
  Text,
  type TextProps,
} from "@noom/wax-component-library";

type CustomTextProps = TextProps & {
  children?: React.ReactNode;
};

const BrownLLText: React.FC<CustomTextProps> = ({ children, ...props }) => (
  <Text
    fontFamily="Brown LL"
    fontWeight={500}
    letterSpacing="0.03em"
    textTransform="uppercase"
    {...props}
  >
    {children}
  </Text>
);

export const TagText: React.FC<CustomTextProps> = ({ children, ...props }) => (
  <BrownLLText fontSize="10px" lineHeight="12px" {...props}>
    {children}
  </BrownLLText>
);

export const CaptionText: React.FC<CustomTextProps> = ({
  children,
  ...props
}) => (
  <BrownLLText fontSize="12px" lineHeight="15px" {...props}>
    {children}
  </BrownLLText>
);

export const TitleText: React.FC<CustomTextProps> = ({
  children,
  ...props
}) => (
  <BrownLLText fontSize="14px" lineHeight="21px" {...props}>
    {children}
  </BrownLLText>
);

export const DisclaimerText: React.FC<CustomTextProps> = ({
  children,
  ...props
}) => (
  <Text
    as="p"
    fontFamily="Untitled Sans"
    fontSize="14px"
    lineHeight="20px"
    {...props}
  >
    {children}
  </Text>
);

export const Tooltip: React.FC<BoxProps> = ({
  backgroundColor,
  children,
  ...props
}) => (
  <Box
    backgroundColor={backgroundColor}
    borderRadius="8px"
    boxShadow={["0px 15px 18px #00000040"]}
    display="flex"
    flexDirection="column"
    padding="var(--spacing-s) var(--spacing-l)"
    position="relative"
    textAlign="center"
    _after={{
      background: backgroundColor,
      bottom: "100%",
      clipPath:
        "path('M13.8617 0.826924C15.7492 4.38537 19.4152 8.23926 24.6861 8.23926H0C5.89255 8.23926 9.52474 3.98293 11.3837 0.759854C11.867 -0.0780106 13.4084 -0.0275488 13.8617 0.826924Z')",
      // eslint-disable-next-line quotes
      content: `" "`,
      height: "8px",
      left: "50%",
      position: "absolute",
      transform: "translateX(-50%)",
      width: "25px",
    }}
    {...props}
  >
    {children}
  </Box>
);
